import requestApi from "../../../api/fetchApi";
import { BranchInterface, CreateOrUpdateBranchInterface } from "../schemas/branches";


export async function getProjectBranches(projectId: string | number): Promise<BranchInterface[]> {
    return requestApi.GET(`/api/projects/${projectId}/branches`);
}


export async function createProjectBranch(projectId: string | number, branch: CreateOrUpdateBranchInterface): Promise<BranchInterface> {
    return requestApi.POST(`/api/projects/${projectId}/branches`, {body: branch});
}


export async function updateProjectBranch(projectId: string | number, branch: CreateOrUpdateBranchInterface): Promise<BranchInterface> {
    return requestApi.PUT(`/api/projects/${projectId}/branches`, {body: branch});
}

export async function deleteProjectBranch(projectId: string | number, branchId: number | string): Promise<void> {
    return requestApi.DELETE(`/api/projects/${projectId}/branches/${branchId}`);
}


export async function deleteUnrelatedBranches(projectId: string | number): Promise<number[]> {
    return requestApi.DELETE(`/api/projects/${projectId}/branches/unrelated`)
        .then((data) => {
            return data.deleted_rows;
        });
}
